import React from 'react'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { formatWeekLabel, getWeekStart } from './utils'

export default function WeekNavigation({ weekStart, onWeekChange }) {
  const weekEnd = new Date(weekStart)
  weekEnd.setDate(weekEnd.getDate() + 6)

  const goToday = () => onWeekChange(getWeekStart(new Date()))
  const goPrev = () => {
    const prev = new Date(weekStart)
    prev.setDate(prev.getDate() - 7)
    onWeekChange(prev)
  }
  const goNext = () => {
    const next = new Date(weekStart)
    next.setDate(next.getDate() + 7)
    onWeekChange(next)
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
      <Button size="small" variant="outlined" onClick={goToday}>
        Today
      </Button>
      <IconButton size="small" onClick={goPrev}>
        <ChevronLeftIcon />
      </IconButton>
      <IconButton size="small" onClick={goNext}>
        <ChevronRightIcon />
      </IconButton>
      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
        {formatWeekLabel(weekStart, weekEnd)}
      </Typography>
    </Stack>
  )
}
